import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  Input,
  IterableDiffers,
  OnChanges,
  OnDestroy,
  OnInit,
  SimpleChanges,
  ViewEncapsulation,
} from '@angular/core';
import { NGXLogger } from 'ngx-logger';
import { Subscription } from 'rxjs';
import { TableEventListMapper } from 'src/app/mapper/table/table-events.mapper';
import { AlarmStateFrench } from 'src/app/shared/models/alarm/alarm-filter';
import { EventLogEntry, EventType } from 'src/swagger-gen/web-secured/models';
import { TableColumn } from '../../tinea-table/models/tableColumn';

@Component({
    selector: 'app-event',
    templateUrl: './event.component.html',
    styleUrls: ['./event.component.css'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class EventComponent implements OnInit, OnDestroy, OnChanges {
  @Input() event: EventLogEntry;

  @Input() tableColumns: TableColumn[] = [];

  differ: any;

  /**
   * Current application language
   */
  language: 'fr' | 'en' = 'fr';

  /**
   * Date format to display depending of language
   */
  dateFormat: string;

  alarmStateFrench = AlarmStateFrench; // translation
  eventTypes = EventType;

  private subscriptions: Subscription[] = [];

  constructor(
    private logger: NGXLogger,
    private ref: ChangeDetectorRef,
    differs: IterableDiffers,
    private tableEventListMapper: TableEventListMapper
  ) {
    this.differ = differs.find([]).create(null);
  }
  ngOnChanges(changes: SimpleChanges): void {
    /* Map events to hide some values from display (ex. false -> '' */
    // const eventMappedValue = this.tableEventListMapper.getValue(
    //   changes.event.currentValue
    // );
    // this.event.value = eventMappedValue;
  }

  ngOnInit() {
    this.setDateFormat();
  }

  /**
   * Set the date format depending on the language
   */
  setDateFormat() {
    if (this.language === 'fr') {
      this.dateFormat = 'dd/MM/yyyy HH:mm:ss';
    } else {
      this.dateFormat = 'MM/dd/yyyy HH:mm:ss';
    }
  }

  ngOnDestroy() {
    if (this.subscriptions !== undefined) {
      this.subscriptions.forEach((s) => s.unsubscribe());
    }
  }

  columnIsDiplayed(propertyName: string): boolean {
    let isDisplayed = false;
    const element = this.tableColumns.find(
      (e) => e.propertyName === propertyName
    );
    if (element) {
      isDisplayed = element.displayed ? true : false;
    }
    return isDisplayed;
  }
}
